// styles
import { labelStyles } from 'styles';

// libraries
import styled, { css } from 'styled-components';
import { TextareaAutosize } from '@mui/material';

interface StyledBasicTextAreaV2Props {
  $labelPosition?: 'top' | 'left';
}

export const StyledBasicTextAreaV2 = styled.div<StyledBasicTextAreaV2Props>`
  ${({ $labelPosition }) =>
    $labelPosition === 'left' &&
    css`
      ${labelStyles}

      .label {
        align-items: baseline !important;
        display: inline-block !important;
      }
    `}

  .label {
    display: flex;
    align-items: center;
    position: relative;
    font-weight: 600;
    margin-bottom: 7px;
    padding-left: 8px;

    .required {
      color: red;
      padding-left: 0;
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }
`;

export const StyledTextareaAutosize = styled(TextareaAutosize)`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 100px;
  max-height: 112px;
  overflow-y: scroll;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
  width: 100%;

  &:hover {
    border-color: #999;
  }

  &:focus {
    outline: none;
    border-color: #b38b3a;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
    opacity: 1;
  }
`;
